'use client';

import React from 'react';
import { TasticComponentProps } from '../types';
import NewsAndEventsDetailsSection from '@/components/organisms/news-and-events-details';

const NewsAndEventsDetailsTastic = ({ data }: any) => {

    console.log("News and events details data here>>>>>>>>>>>>>>>>>>>>", data)
    const news = data?.data?.dataSource
    return <NewsAndEventsDetailsSection news={news} />
};

export default NewsAndEventsDetailsTastic;
